<template>
  <base-table
    title="Machine Tests"
    item-title="Machine Test"
    get-url="/bymachine"
    :headers="headers"
    :url="url"
    :item="machineTest"
    :item-id="machineTest.vesselMachineTestId"
    :get-id="id"
    @set-item="setItem"
  >
    <v-text-field
      v-model="machineTest.order"
      :rules="[rules.required, rules.integer]"
      label="Test Number"
      required
    ></v-text-field>
    <v-text-field
      v-model="machineTest.name"
      :rules="[rules.required]"
      label="Test Name"
      required
    ></v-text-field>
    <v-textarea
      v-model="machineTest.method"
      :rules="[rules.required]"
      label="Method"
      required
    ></v-textarea>
    <v-textarea
      v-model="machineTest.expectedResults"
      :rules="[rules.required]"
      label="Expected Results"
      required
    ></v-textarea
  ></base-table>
</template>

<script>
import ObjectType from '@/services/Objects.js'
import BaseTable from '@/components/tables/BaseTable.vue'
import Validation from '@/mixins/validation.js'

export default {
  name: 'VesselMachineTestTable',
  components: {
    BaseTable
  },
  mixins: [Validation],
  props: {
    id: String
  },
  data() {
    return {
      headers: [
        { text: 'Number', value: 'order', width: '100px', align: 'end' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      machineTest: {
        order: '',
        name: '',
        method: '',
        expectedResults: '',
        vesselMachineId: this.id
      },
      url: ObjectType.VesselMachineTest
    }
  },
  methods: {
    setItem(item) {
      this.machineTest = Object.assign({}, item)
    }
  }
}
</script>

<style scoped></style>
